import { RootState } from '../../../../rootReducer';

export const shipmentReportSelector = (state: RootState) => state.eventsLogModuleReducer.ShipmentReportReducer;
